import api from '../api/client'

const dashboardService = {
  getStats: async (organizadorId, mes = null, ano = null, todoPeriodo = false) => {
    const params = {}
    if (todoPeriodo) { params.todo_periodo = true }
    else { if (mes) params.mes = mes; if (ano) params.ano = ano }
    const response = await api.get(`/organizadores/${organizadorId}/dashboard-stats`, { params })
    return response.data
  },

  getCotacaoBoi: async (cidade, uf) => {
    const params = {}
    if (cidade) params.cidade = cidade
    if (uf) params.uf = uf
    const response = await api.get('/cotacao/boi-gordo', { params })
    return response.data
  },

  getLeilaoTempoReal: async (organizadorId, leilaoId = null) => {
    const params = leilaoId ? `?leilao_id=${leilaoId}` : ''
    const response = await api.get(`/organizadores/${organizadorId}/leilao-tempo-real${params}`)
    return response.data
  },
}

export default dashboardService
